<div class="main-content">
  <div id="register-recaptcha-container"></div>

  <!-- MAIN DIALOG WRAPPER -->
  <div class="register-dialog">
    <!-- HEADER -->
    <div class="dialog-header">
      <h3 class="dialog-title">Create Account</h3>
    </div>

    <!-- ========================= -->
    <!-- STEP 1 — Create account -->
    <!-- ========================= -->
    <div *ngIf="step === 1" class="step-1">
      <h2 class="welcome-title">
        {{
        otpSent ? "Confirm your number" : "Welcome to the Aluguloo family!"
        }}
      </h2>

      <!-- OTP VIEW -->
      <div *ngIf="otpSent && !otpVerified" class="otp-container">
        <p class="otp-text">
          Enter the code we sent to {{ user.countryCode }}
          {{ user.phoneNumber }}
        </p>

        <div class="otp-inputs">
          <input *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIdx" type="tel" [id]="'otp-' + i"
            maxlength="6" class="otp-box" [value]="otpDigits[i]" (input)="moveFocus($event, i)"
            (keydown)="handleBackspace($event, i)" />
        </div>

        <a class="resend-link" (click)="otpSent = false">Choose another option to get the code</a>

        <button type="button" class="primary-cta" (click)="verifyOtp()">
          Continue
        </button>
      </div>

      <!-- LOGIN/REGISTER VIEW -->
      <div *ngIf="!otpSent">
        <!-- MOBILE SIGNUP -->
        <form *ngIf="signupMethod === 'mobile'" #mobileForm="ngForm" class="form">
          <div class="phone-row mb-12">
            <!-- Country Code -->
            <div class="country-select">
              <label class="input-label">&nbsp;</label>
              <div class="custom-input-box">
                <mat-select [(ngModel)]="user.countryCode" name="countryCode" panelClass="wide-country-dropdown"
                  disableOptionCentering>
                  <mat-select-trigger>
                    <div class="flex-center" *ngIf="getSelectedCountry() as selected">
                      <img [src]="selected.flag" class="flag-icon-small" />
                      {{ selected.code }}
                    </div>
                  </mat-select-trigger>
                  <mat-option *ngFor="let c of countryList" [value]="c.code">
                    <img [src]="c.flag" class="flag-icon" />
                    {{ c.name }} ({{ c.code }})
                  </mat-option>
                </mat-select>
              </div>
            </div>

            <!-- Phone -->
            <div class="phone-input flex-1">
              <label class="input-label">Phone number <span class="required-star">*</span></label>
              <div class="custom-input-box" [class.error]="submitted && !user.phoneNumber">
                <mat-icon class="prefix-icon">phone</mat-icon>
                <input type="text" [(ngModel)]="user.phoneNumber" name="phoneNumber"
                  [maxlength]="currentPhoneLimit" (keypress)="numberOnly($event)" placeholder="Ex: 501234567" />
              </div>
              <div class="error-msg" *ngIf="submitted && !user.phoneNumber">
                Phone is required
              </div>
            </div>
          </div>

          <!-- Terms Checkbox -->
          <div class="terms-checkbox-wrapper">
            <mat-checkbox [checked]="termsAccepted" (change)="onTermsCheckboxChange($event)">
              I agree to the <a (click)="openTermsDialog($event)" style="color: #57c4ef; cursor: pointer; text-decoration: underline;">Terms and Conditions</a>
            </mat-checkbox>
          </div>

          <!-- Get OTP -->
          <button type="button" class="primary-cta" (click)="sendOtp()" [disabled]="!termsAccepted">
            Get OTP
          </button>
        </form>

        <!-- EMAIL SIGNUP (Redesigned to match register-business) -->
        <form *ngIf="signupMethod === 'email'" #emailForm="ngForm" class="form">
          <!-- Email -->
          <div class="full-width mb-12">
            <label class="input-label">Email ID <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="submitted && !user.emailid">
              <mat-icon class="prefix-icon">mail_outline</mat-icon>
              <input type="email" placeholder="Ex: user@example.com" [(ngModel)]="user.emailid" name="emailid" required email
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
            </div>
            <div class="error-msg" *ngIf="submitted && !user.emailid">
              Email is required
            </div>
          </div>

          <!-- Password -->
          <div class="full-width mb-12">
            <label class="input-label">Password <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="submitted && !user.password">
              <mat-icon class="prefix-icon">lock_outline</mat-icon>
              <input [type]="hidePassword ? 'password' : 'text'" placeholder="Enter password" [(ngModel)]="user.password"
                name="password" required />
              <mat-icon class="eye-icon" (click)="hidePassword = !hidePassword">{{
                hidePassword ? "visibility_off" : "visibility"
                }}</mat-icon>
            </div>
            <div class="error-msg" *ngIf="submitted && !user.password">
              Password is required
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="full-width mb-12">
            <label class="input-label">Confirm Password <span class="required-star">*</span></label>
            <div class="custom-input-box" [class.error]="submitted && (!confirmPassword || confirmPassword !== user.password)">
              <mat-icon class="prefix-icon">lock_outline</mat-icon>
              <input [type]="hideConfirmPassword ? 'password' : 'text'" placeholder="Confirm password"
                [(ngModel)]="confirmPassword" name="confirmPassword" required />
              <mat-icon class="eye-icon" (click)="hideConfirmPassword = !hideConfirmPassword">{{
                hideConfirmPassword ? "visibility_off" : "visibility"
                }}</mat-icon>
            </div>
            <div class="error-msg" *ngIf="submitted && !confirmPassword">
              Confirm password is required
            </div>
            <div class="error-msg" *ngIf="submitted && confirmPassword && confirmPassword !== user.password">
              Passwords do not match
            </div>
          </div>

          <!-- Terms Checkbox -->
          <div class="terms-checkbox-wrapper">
            <mat-checkbox [checked]="termsAccepted" (change)="onTermsCheckboxChange($event)">
              I agree to the <a (click)="openTermsDialog($event)" style="color: #57c4ef; cursor: pointer;">Terms and Conditions</a>
            </mat-checkbox>
          </div>

          <button type="button" class="primary-cta" (click)="registerWithEmail(emailForm)" [disabled]="!termsAccepted">
            Create Account
          </button>
        </form>

        <!-- Divider -->
        <div class="divider"><span>or</span></div>

        <!-- Social Buttons (Refactored to match register-business layout) -->
        <div class="socials">
          <button type="button" class="social-button" (click)="googleSignup()" [disabled]="!termsAccepted">
            <img class="social-icon" src="assets/icons/google.png" alt="Google" />
            <span>Continue with Google</span>
          </button>

          <!-- Toggle Email/Mobile -->
          <button type="button" class="social-button" (click)="
              switchSignupMethod(signupMethod === 'mobile' ? 'email' : 'mobile')
            ">
            <mat-icon class="social-icon" style="font-size: 18px">
              {{ signupMethod === "mobile" ? "mail" : "phone_iphone" }}
            </mat-icon>
            <span>{{
              signupMethod === "mobile"
              ? "Continue with Email"
              : "Continue with Mobile Number"
              }}</span>
          </button>
        </div>

        <!-- FOOTER -->
        <div class="footer-area">
          <div class="register-section">
            <span class="register-text">Already have an account?</span>
            <a class="register-link" (click)="handleBack()">Log in</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>